
export default function GRReportTypesController(
) {
  const vm = this;

  vm.orderBy = '-lastGeneratedDate';

  vm.handleSort = handleSort;

  _activate();

  function handleSort(propertyName) {
    if (vm.orderBy === propertyName) {
      if (propertyName.startsWith('-')) {
        propertyName = propertyName.substring(1);
      } else {
        propertyName = `-${propertyName}`;
      }
    }
    vm.orderBy = propertyName;
  }

  /** ********************************************
   * Private Functions
   */

  function _activate() {
  }
}

GRReportTypesController.$inject = [
];
